import React, { useState, useEffect } from "react";
import api from "@api";
import "./SponsorSlideshow.css";

function SponsorSlideshow({ banners = [], rotationSpeed = 5, animation = "fade" }) {
  const [index, setIndex] = useState(0);

  // Rotate banners
  useEffect(() => {
    if (!banners.length) return;

    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % banners.length);
    }, rotationSpeed * 1000);

    return () => clearInterval(interval);
  }, [banners.length, rotationSpeed]);

  if (!banners.length) return null;

  const current = banners[index];

  const finalUrl = current.link_url?.startsWith("http")
    ? current.link_url
    : current.link_url
      ? `https://${current.link_url}`
      : null;

  const handleClick = async () => {
    try {
      // 🔥 Track click in backend
      await api.post(`/api/organization-banner/banner-click/${current.id}`);
    } catch (err) {
      console.error("Banner click tracking failed:", err);
    }

    if (finalUrl) {
      window.open(finalUrl, "_blank");
    }
  };

  return (
    <div
      key={index}
      className={`slideshow-container ${animation}`}
      onClick={handleClick}
      style={{ cursor: finalUrl ? "pointer" : "default" }}
    >
      <img
        src={current.image_url}
        className="slideshow-image"
        alt="Banner"
      />
    </div>
  );
}

export default SponsorSlideshow;